module.exports = __webpack_public_path__ + "img/5.63425b19.png";